import angular from 'angular';
import moment from 'moment-timezone';

import {} from './od-footer-nonmarketing.less';

module.exports = angular.module('market.components.od-footer-nonmarketing', [])
.component('odFooterNonmarketing', {
  template: require('./od-footer-nonmarketing.jade')(),
  controller: class {
    constructor() {
      this.currentYear = moment().year();
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-footer-nonmarketing.js
 **/